import { heicTo } from 'heic-to'
import path from 'path'
import { useEffect, useMemo, useState } from 'react'

import { getDefaultAvatar } from 'src/utils/avatar'

export interface AvatarProps {
  avatar?: string | null
  name: string
  size?: 'small' | 'normal' | 'large'
}

export const Avatar = ({
  avatar = null,
  name,
  size = 'normal'
}: AvatarProps) => {
  const sizeClasses = useMemo(() => {
    if (size === 'small') return 'w-[50px] h-[50px]'
    if (size === 'large') return 'w-[60px] h-[60px]'
    return 'h-14 w-14'
  }, [size])

  const [backgroundImage, setBackgroundImage] = useState<string>('')

  useEffect(() => {
    const getAvatarImageUrl = async () => {
      try {
        const avatarUrl = getDefaultAvatar(name, avatar)
        const extension = path.extname(avatarUrl)
        if (!extension.toLowerCase().startsWith('.heic')) {
          setBackgroundImage(avatarUrl)
          return
        }
        const response = await fetch(avatarUrl)
        const blob = await response.blob()

        const convertedBlob = await heicTo({
          blob,
          type: 'image/jpeg',
          quality: 1
        })

        const objectUrl = URL.createObjectURL(convertedBlob as Blob)
        setBackgroundImage(objectUrl)
      } catch {
        setBackgroundImage(getDefaultAvatar(name, null))
      }
    }
    getAvatarImageUrl()
  }, [name, avatar])

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
      className={`bg-center bg-cover p-4 rounded-full font-bold text-white flex justify-center align-middle ${sizeClasses}`}
    />
  )
}
